import * as React from "react";
import { Provider } from "./auth-service-tools115.js";
import { createIntlCache, invariantIntlContext, DEFAULT_INTL_CONFIG, createFormatters } from "./auth-service-tools117.js";
import { formatNumber, formatNumberToParts } from "./auth-service-tools118.js";
import { formatRelativeTime } from "./auth-service-tools119.js";
import { formatDate, formatDateToParts, formatTime, formatTimeToParts } from "./auth-service-tools120.js";
import { formatPlural } from "./auth-service-tools121.js";
import { formatMessage } from "./auth-service-tools122.js";
import * as index from "./auth-service-tools123.js";
import index$1 from "./auth-service-tools123.js";
import { formatList } from "./auth-service-tools124.js";
import { formatDisplayName } from "./auth-service-tools125.js";
import { InvalidConfigError, MissingDataError } from "./auth-service-tools126.js";

var __extends = globalThis && globalThis.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d2, b2) {
      d2.__proto__ = b2;
    } || function (d2, b2) {
      for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = globalThis && globalThis.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var shallowEquals = index$1 || index;

function processIntlConfig(config) {
  return {
    locale: config.locale,
    timeZone: config.timeZone,
    formats: config.formats,
    textComponent: config.textComponent,
    messages: config.messages,
    defaultLocale: config.defaultLocale,
    defaultFormats: config.defaultFormats,
    onError: config.onError,
    wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment
  };
}

function createIntl(config, cache) {
  var formatters = createFormatters(cache);

  var resolvedConfig = __assign(__assign({}, DEFAULT_INTL_CONFIG), config);

  var locale = resolvedConfig.locale,
      defaultLocale = resolvedConfig.defaultLocale,
      onError = resolvedConfig.onError;

  if (!locale) {
    if (onError) {
      onError(new InvalidConfigError('"locale" was not configured, using "' + defaultLocale + '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details'));
    }

    resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
  } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) {
    onError(new MissingDataError('Missing locale data for locale: "' + locale + '" in Intl.NumberFormat. Using default locale: "' + defaultLocale + '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'));
  } else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) {
    onError(new MissingDataError('Missing locale data for locale: "' + locale + '" in Intl.DateTimeFormat. Using default locale: "' + defaultLocale + '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'));
  }

  return __assign(__assign({}, resolvedConfig), {
    formatters,
    formatNumber: formatNumber.bind(null, resolvedConfig, formatters.getNumberFormat),
    formatNumberToParts: formatNumberToParts.bind(null, resolvedConfig, formatters.getNumberFormat),
    formatRelativeTime: formatRelativeTime.bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
    formatDate: formatDate.bind(null, resolvedConfig, formatters.getDateTimeFormat),
    formatDateToParts: formatDateToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat),
    formatTime: formatTime.bind(null, resolvedConfig, formatters.getDateTimeFormat),
    formatTimeToParts: formatTimeToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat),
    formatPlural: formatPlural.bind(null, resolvedConfig, formatters.getPluralRules),
    formatMessage: formatMessage.bind(null, resolvedConfig, formatters),
    formatList: formatList.bind(null, resolvedConfig, formatters.getListFormat),
    formatDisplayName: formatDisplayName.bind(null, resolvedConfig, formatters.getDisplayNames)
  });
}

var IntlProvider =
/** @class */
function (_super) {
  __extends(IntlProvider2, _super);

  function IntlProvider2() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.cache = createIntlCache();
    _this.state = {
      cache: _this.cache,
      intl: createIntl(processIntlConfig(_this.props), _this.cache),
      prevConfig: processIntlConfig(_this.props)
    };
    return _this;
  }

  IntlProvider2.getDerivedStateFromProps = function (props, _a) {
    var prevConfig = _a.prevConfig,
        cache = _a.cache;
    var config = processIntlConfig(props);

    if (!shallowEquals(prevConfig, config)) {
      return {
        intl: createIntl(config, cache),
        prevConfig: config
      };
    }

    return null;
  };

  IntlProvider2.prototype.render = function () {
    invariantIntlContext(this.state.intl);
    return /*#__PURE__*/React.createElement(Provider, {
      value: this.state.intl
    }, this.props.children);
  };

  IntlProvider2.displayName = "IntlProvider";
  IntlProvider2.defaultProps = DEFAULT_INTL_CONFIG;
  return IntlProvider2;
}(React.PureComponent);

const ReactIntlProvider = IntlProvider;
export { createIntl, ReactIntlProvider as default };